module.exports = __webpack_public_path__ + "img/suger.4249d15a.svg";